module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!!_vm.loggedIn) ? _c('form', {
    staticClass: "FavoriteForm FavoriteForm--billboard",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(!_vm.favorited) ? _c('button', {
    staticClass: "Button Button--toggle Button--soft-black",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addFavorite
    }
  }, [_c('icon', {
    attrs: {
      "icon": "plus"
    }
  }), _vm._v("\n    Favorite\n  ")], 1) : _vm._e(), _vm._v(" "), (_vm.favorited) ? _c('button', {
    staticClass: "Button Button--toggle Button--soft-black",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.removeFavorite
    }
  }, [_c('icon', {
    attrs: {
      "icon": "minus"
    }
  }), _vm._v("\n    Favorite\n  ")], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-732ade26","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/add-favorite.vue
// module id = 342
// module chunks = 0